import React, { useState, useEffect } from 'react';
import { Box, Button, Card, CardContent, CardHeader, Divider, TextField, Typography, Container, FormControlLabel, Grid, Checkbox } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export const Settings = () => {
  const { currentUser, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const [values, setValues] = useState({
    oldPassword: '',
    password: '',
    confirm: ''
  });

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/auth');
    }
  }, [isAuthenticated, navigate]);

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
    setError('');
    setSuccess('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (values.password !== values.confirm) {
      return setError("Passwords do not match");
    }

    if (values.password.length < 6) {
      return setError("Password should be at least 6 characters");
    }

    try {
      setError('');
      setSuccess('');
      setLoading(true);

      const baseURL = process.env.REACT_APP_API_URL;
      
      const response = await axios.post(
        `${baseURL}/auth/change-password`,
        {
          oldPassword: values.oldPassword,
          newPassword: values.password
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        }
      );

      if (response.data.success) {
        setSuccess('Password updated successfully');
        setValues({ oldPassword: '', password: '', confirm: '' });
      } else {
        setError(response.data.message || 'Failed to update password');
      }
    } catch (err) {
      console.error('Error details:', err.response || err);
      if (err.response?.data) {
        setError(err.response.data.message || 'Failed to update password');
      } else {
        setError('An error occurred while updating password');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
  <>    
      <title>
        Settings | Material Kit
      </title>
    <Box component="main" sx={{ flexGrow: 1, py: 8 }} >
      <Container maxWidth="lg">
        <Typography sx={{ mb: 3 }} variant="h4" >
          Settings
        </Typography>
        <Box sx={{ pt: 3 }}>
          <Card>
            <CardHeader subheader="Update password" title="Password" />
            <Divider />
            <CardContent>
              {error && (
                <Typography color="error" sx={{ mb: 2 }}>
                  {error}
                </Typography>
              )}
              {success && (
                <Typography color="success.main" sx={{ mb: 2 }}>
                  {success}
                </Typography>
              )}
              <form onSubmit={handleSubmit}>
                <TextField
                  fullWidth
                  label="Old Password"
                  margin="normal"
                  name="oldPassword"
                  onChange={handleChange}
                  type="password"
                  value={values.oldPassword}
                  variant="outlined"
                  required
                />
                <TextField
                  fullWidth
                  label="New Password"
                  margin="normal"
                  name="password"
                  onChange={handleChange}
                  type="password"
                  value={values.password}
                  variant="outlined"
                  required
                />
                <TextField
                  fullWidth
                  label="Confirm password"
                  margin="normal"
                  name="confirm"
                  onChange={handleChange}
                  type="password"
                  value={values.confirm}
                  variant="outlined"
                  required
                />
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
                  <Button 
                    color="primary" 
                    variant="contained" 
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? 'Updating...' : 'Update'}
                  </Button>
                </Box>
              </form>
            </CardContent>
          </Card>
        </Box>
      </Container>
    </Box>
  </>      

  );
};